import { Card, Container } from '@mui/material';
import { getMaskedAccountId, IUser, mailTo, Pair } from '../common';
import { pathOr } from 'rambda';

export function ViewUserProfileDetails({ user }: { user: IUser }) {
  return (
    <Container maxWidth="xl">
      <Card>
        <h4>Subscriber Information</h4>
        <Pair name="Account Id" value={getMaskedAccountId(user)} />
        <Pair name="Email" value={user.loginEmail} />
        <Pair name="Phone" value={pathOr('', 'phone')(user)} />
        {user.address && (
          <Pair
            name="Business Mailing Address"
            value={user.address && mailTo(user.address)}
          />
        )}
      </Card>
    </Container>
  );
}
